"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isCheckedIndex = isCheckedIndex;
exports.isChecked = isChecked;
function isCheckedIndex(selectedValue, value) {
    return selectedValue.findIndex(function (x) {
        return x == value;
    });
}

function isChecked(selectedValue, value) {
    return isCheckedIndex(selectedValue, value) > -1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-checkbox@0.0.1@@alicd/crui-checkbox/lib/util.js
// module id = 262
// module chunks = 0